import { ApiClientManager, InitInputDto, InitOutputDtoSingleOutputMessage } from '@api/consumerloans-public-api';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { useLoadingStore, usePTCMetadata, useServicesStore, useTempStore } from '@store';
import { BaseSessionInfo } from '@types';

export const useFetchInit = (
	sessionInfo: BaseSessionInfo
): UseFetchHookOutput<InitInputDto, InitOutputDtoSingleOutputMessage> => {
	const saveServiceResponse = useServicesStore((state) => state.saveServiceResponse);
	const saveCreditTypeSelected = useTempStore((state) => state.saveCreditTypeSelected);
	const saveSimulationInputData = useTempStore((state) => state.saveSimulationInputData);
	const setIsLoadingInit = useLoadingStore((state) => state.setIsLoadingInit);

	return useFetch<InitInputDto, InitOutputDtoSingleOutputMessage>({
		fetchFn: (data: InitInputDto) =>
			ApiClientManager.call.init({
				data: {
					...data,
					metadata: {
						application: sessionInfo.application,
						geo: sessionInfo.geo,
						languageCode: sessionInfo.language.toLowerCase(),
						targetSystem: sessionInfo.targetSystem,
					},
				},
			}),
		onSuccess: (res: InitOutputDtoSingleOutputMessage) => {
			if (res.data?.configurations) {
				const creditTypeSelectedDefault = res.data.configurations.filter(
					(x) => x.creditType === sessionInfo.journeyData.loanType
				);

				const defaultValues = creditTypeSelectedDefault[0].termCardsConfig?.filter(
					(termCard) => termCard.useDefault
				);
				const { defaultAmount = undefined, defaultDuration = undefined } =
					defaultValues && defaultValues?.length > 0 ? defaultValues[0] : {};

				saveSimulationInputData({
					amount: sessionInfo?.journeyData.amount
						? +sessionInfo?.journeyData.amount.toString().trim()
						: defaultAmount || undefined,
					term: sessionInfo?.journeyData.term
						? +sessionInfo?.journeyData.term.toString().trim()
						: defaultDuration || undefined,
				});
				saveServiceResponse({ init: res.data || {} });
				saveCreditTypeSelected(creditTypeSelectedDefault[0]);
				setIsLoadingInit(false);
			}
		},
		onError: () => {
			setIsLoadingInit(false);
		},
		notShowLoading: true,
	});
};
